{
  "appName": "VRE CH31 Eligibility &amp; Entitlement",
  "entryFile": "./app-entry.jsx",
  "entryName": "ch31-eligibility-entitlement",
  "rootUrl": "/careers-employment/your-vre-eligibility",
  "productId": "6f0fff93-4ba6-4500-8eda-c1500c433c67"
}
